import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineDot from "@mui/lab/TimelineDot";

import { LuGraduationCap } from "react-icons/lu";
import { PiCertificate } from "react-icons/pi";
import { FaSchoolFlag } from "react-icons/fa6";

import Card from "@mui/material/Card";

import Typography from "@mui/material/Typography";
// import Education from './Education';

export default function Education() {
  return (
    <Card sx={{ marginTop: "15px", marginBottom: "15px" }}>
      <Timeline position="alternate">
        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            align="right"
            variant="body2"
            color="text.secondary"
          >
            2017-2019
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineConnector sx={{ bgcolor: "warning.main" }} />
            <TimelineDot color="warning" variant="outlined">
              <FaSchoolFlag />
            </TimelineDot>
            <TimelineConnector sx={{ bgcolor: "success.main" }} />
          </TimelineSeparator>
          <TimelineContent sx={{ py: "12px", px: 2 }}>
            <Typography variant="h6" component="span">
              Hsc
            </Typography>
            <Typography>
              {" "}
              Smt.Sushiladevi Deshmukh College of Arts, Science & Commerce Navi
              Mumabi
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
          >
            2019-2022
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineConnector sx={{ bgcolor: "success.main" }} />
            <TimelineConnector sx={{ bgcolor: "success.main" }} />
            <TimelineDot color="success" variant="outlined">
              <LuGraduationCap />
            </TimelineDot>
            <TimelineConnector sx={{ bgcolor: "primary.main" }} />
          </TimelineSeparator>
          <TimelineContent sx={{ py: "12px", px: 2 }}>
            <Typography variant="h6" component="span">
              Bsc Computer science
            </Typography>
            <Typography>Mumbai University</Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineOppositeContent
            sx={{ m: "auto 0" }}
            variant="body2"
            color="text.secondary"
          >
            2023-2023
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineConnector sx={{ bgcolor: "primary.main" }} />
            <TimelineDot color="primary" variant="outlined">
              <PiCertificate />
            </TimelineDot>
            <TimelineConnector sx={{ bgcolor: "secondary.main" }} />
          </TimelineSeparator>
          <TimelineContent sx={{ py: "12px", px: 2 }}>
            <Typography variant="h6" component="span">
              10x Academy
            </Typography>
            <Typography> Full Stack Web Developement Bootcamp</Typography>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </Card>
  );
}
